module.exports = __webpack_public_path__ + "img/La-Tribune-header.fb27276a.jpg";